module.exports = new __parcel__URL__("shop_machines_community_hero_2023.d6a7dee2.png").toString();